import { render, staticRenderFns } from "./ProjectDocumentNewFrProject.vue?vue&type=template&id=6ce21ffe&"
import script from "./ProjectDocumentNewFrProject.vue?vue&type=script&lang=js&"
export * from "./ProjectDocumentNewFrProject.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports